import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "src/components/Avatar";
// import { StarRating } from "src/components/StarRating";
import { Show } from "src/components/PrivateRoute/Show";
import { ONLY_FOR } from "src/components/PrivateRoute/types";
import { CardInfoParam } from "src/components/Card/CardInfoParam";
import { ViewersLabel } from "src/components/Card/ViewersLabel";
import { AddToFavorite } from "src/components/Card/AddToFavoriteButton/AddToFavorite";
import { getImageUrl } from "src/utils/getImageUrl";
import { IClone } from "src/@types/clones";
import { Sizes } from "src/@types/sizes";
import { infoParamsTrns } from "../trns";

export const TopPopularCloneCardHeader: FC<IClone> = ({
  id,
  company_name,
  logo,
  website,
  views_count,
  saved_count,
  isFavorite,
  host,
}) => {
  const { t } = useTranslation();

  const [isFavoriteClone, setIsFavoriteClone] = useState(isFavorite);

  return (
    <div className="flex flex-col lg:flex-row items-start gap-5 overflow-hidden">
      <Avatar
        sizeVariant={Sizes.S}
        avatarUrl={getImageUrl(logo)}
        altText={company_name}
      />

      <div className="flex-1 flex flex-col xl:flex-row justify-between items-start xl:items-center gap-5">
        <div className="flex flex-col gap-1">
          {/* this part will be next release */}

          {/* <CardInfoParam label={t(infoParamsTrns.rating)}>
          <StarRating rating={rating} />
        </CardInfoParam> */}

          <CardInfoParam
            label={t(infoParamsTrns.phone)}
            href={`tel:${host?.phone_number}`}
          >
            {host?.phone_number}
          </CardInfoParam>

          <CardInfoParam
            label={t(infoParamsTrns.website)}
            href={website}
            isOpenNewTab
          >
            {website}
          </CardInfoParam>
        </div>

        <div className="flex items-center justify-center gap-5">
          <ViewersLabel viewsCount={views_count} />
          <Show onlyFor={ONLY_FOR.AGENT}>
            <AddToFavorite
              id={id}
              saved_count={saved_count}
              isFavorite={isFavoriteClone}
              setIsFavorite={setIsFavoriteClone}
            />
          </Show>
        </div>
      </div>
    </div>
  );
};
